<template>
  <div class="contents">
    <common-header
      :menu="headerMenu"
      :mute="mute"
      :camera-mode="currentCameraMode"
      @button-clicked="onButtonClicked"
      @camera-mode-change="onCameraChange" />
    <settings-modal ref="settings" :settings="settings"
                    :display-value="displayValue"
                    @camera-mode-change="onCameraChange"
                    @settings-change="onSettingChange" />
    <common-display :debug-meg="debugMeg" :navigations="navigations" />
    <side-menu v-show="canShowSideMenu" :menu="sideMenu"
               @button-clicked="onButtonClicked" />
    <section v-show="showScore && canShowHeaderMenu" class="score-boards">
<!--      <score-board title="運動時間" :value="timeStr" font-size="4vh" class="score-borad" />-->
      <score-board title="距離" :value="score" unit="m" :min-length="4" class="score-borad" />
      <score-board title="時速" :value="speedStr" unit="km/h" font-size="4vh" class="score-borad" />
    </section>
    <title-label :title="title"/>
    <common-modal ref="modal" :steps="steps"/>
    <fill-camera-layout
      @camera-required="start"
      :device-state="deviceState"
      :camera-state="manager ? manager.state : null"/>
    <common-footer v-show="canShowFooterMenu" :menu="footerMenu" />
  </div>
</template>

<script>
import "@pqina/flip/dist/flip.min.css";
import {Jogging} from '../game/Jogging'
import SettingButton from "../SettingButton";
import Separator from "../Separator";
import CommonHeader from "../CommonHeader";
import {CAMERA_MODE} from '../common/CameraRenderer'
import {CommonMixin} from '../common/CommonMixin'
import FillCameraLayout from "../FillCameraLayout";
import CommonDisplay from "../CommonDisplay";
import CommonFooter from "../CommonFooter";
import ScoreBoard from "../common/ScoreBoard";
import SettingsModal from "../common/SettingsModal";
import CommonModal from "../common/CommonModal";
import SideMenu from "../SideMenu";
import TitleLabel from "../common/TitleLabel";

export default {
  name: 'Jogging',
  mixins: [CommonMixin],
  components: {TitleLabel, SideMenu, CommonModal, SettingsModal, ScoreBoard, CommonFooter, CommonDisplay, FillCameraLayout, CommonHeader, Separator, SettingButton},
  data () {
    return {
      showScore: false,
      defaultCameraMode: CAMERA_MODE.FIGURE,
      headerMenu: Object.assign({}, this.defaultHeaderMenu(), {  }),
      sideMenu: Object.assign({}, this.defaultSideMenu(), {}),
      footerMenu: Object.assign({}, this.defaultFooterMenu(), {}),
      settings: [
        { key: 'poseToDist', type: 'range', label: '反応しやすさ', default: 8, step:1, min:1, max:25 },
      ],
      steps: [
        'カメラに両膝が映る位置に立ちます',
        'その場でジョギングすれば距離や速度が計測されます',
      ],
      speed: 0,
      timeSec: 0,
    }
  },
  computed: {
    title() {
      return 'ジョギング'
    },
    desc() {
      return 'その場ジョギング'
    },
    timeStr() {
      if (this.timeSec === null) {
        return '00:00'
      }
      let t = this.timeSec
      let sec = t % 60
      t -= sec
      t = Math.floor(t/60)
      return `${t.toString().padStart(2, '0')}:${sec.toString().padStart(2, '0')}`
    },
    speedStr() {
      if (this.speed === null) {
        return 0
      }
      return this.speed.toFixed(1).toString().padStart(4,'0')
    }
  },
  methods: {
    createContents() {
      return new Jogging();
    },
    setScores() {
      this.score = Math.round(this.manager.game.score)
      this.speed = this.manager.game.speed
      this.timeSec = this.manager.game.timeSec
      this.navigations = this.manager.game.navigations
      this.debugMeg = this.manager.game.debug

      if (this.speed >= 2.0) {
        this.showScore = true
      }
    }
  }
}
</script>

<style scoped>
.score-borad {
  margin: 0 auto;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/contents-page/Jogging.vue